import { RecordCard } from "../../../../Records/shared/RecordCard.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import { RecordPickModal } from "../../../../Records/shared/RecordPickModal/index.js";
import { useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { IoMdAdd } from "react-icons/io";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Record/Form.tsx
var RecordFieldForm = ({ config }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	const removeRecord = (recordId) => {
		if (valuesByFieldId[config.id]) {
			let newValue = void 0;
			if (config.options.multi) {
				const recordIndex = valuesByFieldId[config.id].indexOf(recordId);
				newValue = valuesByFieldId[config.id].toSpliced(recordIndex, 1);
			}
			fieldValueChanged(config.id, newValue);
		}
	};
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsxs("div", {
			className: "space-x-xs",
			children: [
				/* @__PURE__ */ jsx("span", {
					className: "font-medium",
					children: config.options.label || config.options.formLabel
				}),
				config.options.required && /* @__PURE__ */ jsx("span", {
					className: "text-color-critical text-sm font-light",
					children: "Required"
				}),
				config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})
			]
		}),
		!!config.options.subText && /* @__PURE__ */ jsx("div", {
			className: "text-color-subtle text-sm",
			children: config.options.subText
		}),
		/* @__PURE__ */ jsxs("div", {
			className: "mt-sm gap-xxs flex flex-wrap",
			children: [Array.isArray(valuesByFieldId[config.id]) ? valuesByFieldId[config.id].map((recordId) => /* @__PURE__ */ jsx("div", {
				className: "max-w-80",
				children: /* @__PURE__ */ jsx(RecordCard, {
					onDelete: removeRecord,
					recordId
				})
			}, recordId)) : !!valuesByFieldId[config.id] && /* @__PURE__ */ jsx("div", {
				className: "max-w-80",
				children: /* @__PURE__ */ jsx(RecordCard, {
					onDelete: removeRecord,
					recordId: valuesByFieldId[config.id]
				})
			}), /* @__PURE__ */ jsx("div", {
				className: "bg-surface-subtle border-main-faded hover:border-main flex rounded border-2 border-dashed transition",
				children: /* @__PURE__ */ jsxs(Button, {
					onClick: () => setIsModalOpen(true),
					className: "shrink-0 justify-center",
					borderRadius: "none",
					variant: "main",
					size: "lg",
					subtle: true,
					children: [/* @__PURE__ */ jsx(Icon, {
						Icon: IoMdAdd,
						className: "mr-xxs"
					}), /* @__PURE__ */ jsx("span", {
						className: "mr-xxs text-sm",
						children: "Add"
					})]
				})
			})]
		}),
		!!errorsByFieldId[config.id] && /* @__PURE__ */ jsx("div", {
			className: "text-color-critical mt-sm",
			children: errorsByFieldId[config.id]
		}),
		isModalOpen && /* @__PURE__ */ jsx(RecordPickModal, {
			closeHandler: () => setIsModalOpen(false),
			multi: config.options.multi,
			onSubmit: (recordIds) => fieldValueChanged(config.id, recordIds),
			recordIds: valuesByFieldId[config.id]
		})
	] });
};
//#endregion
export { RecordFieldForm };

//# sourceMappingURL=Form.js.map